//
// Module for the Benefit 415 Assumptions Index view
//
rs.module("content/system_/configuration/benefit415assumptions/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {

            var criteria = $.js(jsSelectors.criteria);

            var groupNameSelect = criteria.js(jsSelectors.groupNameSelect);
            var loadingSpinner = criteria.js(jsSelectors.loadingSpinner);

            // listen for group name dropdown change
            groupNameSelect.change(groupChanged);

            // Hookup Ajax to changing the selected group name
            function groupChanged() {

                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { groupName: $(groupNameSelect).find(":selected").text() },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);